
import { FETCH_PET_QUEUE_RECORDS, RETRY_FETCH_CONTRACT } from '../actions';
const initialState = {
  petQueueRecords: [],
  retryFetchContractResult: null,
  loading: false,
  petQueueRecordsError: null,
  retryFetchContractError: null
};

function wooStoreReducer(state = initialState, action) {
  let petQueueRecords,
      retryFetchContractResult;
  switch (action.type) {
    case `${FETCH_PET_QUEUE_RECORDS}_PENDING`:
    case `${RETRY_FETCH_CONTRACT}_PENDING`:
      return { ...state, 
        loading: true,
        petQueueRecordsError: null,
        retryFetchContractError: null,

        retryFetchContractResult: null
      };

    case `${FETCH_PET_QUEUE_RECORDS}_FULFILLED`:
        petQueueRecords = action.payload.data;
      return { ...state, loading: false, petQueueRecords };

    case `${FETCH_PET_QUEUE_RECORDS}_REJECTED`:
      return {...state, loading: false, petQueueRecordsError: action.payload.response.data, state: initialState };

    case `${RETRY_FETCH_CONTRACT}_FULFILLED`:
      retryFetchContractResult = action.payload.data;
      return { ...state, loading: false, retryFetchContractResult };

    case `${RETRY_FETCH_CONTRACT}_REJECTED`:
      return {...state, loading: false, retryFetchContractError: action.payload.response.data, state: initialState };
    
    default:
      return state;
  }
}

export default wooStoreReducer;